import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class CourseType {
  public id: number;
  public name: string;
}

export class Course {
  public id: number;
  public name_it: string;
  public name_de: string;
  public name_en: string;
  public description_it: string;
  public description_de: string;
  public description_en: string;
  public enable: boolean;
  public course: boolean;
  public courseType: CourseType;
}

@Injectable({
  providedIn: 'root'
})
export class CoursesService {

  private _courses: Course[] = [];
  public courses: Subject<Course[]> = new Subject();
  public courseDeleteIndex: Subject<number> = new Subject();
  public courseUpdateIndex: Subject<number> = new Subject();

  public getCourses() {
    return this._courses.slice();
  }

  constructor(private _http: HttpClient) { }


  /**
   * getAllCourseTypes
   */
  public getAllCourseTypes() {
    return this._http.get<[CourseType]>(environment.serverUrl + 'coursetype/all').pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }


  /**
   * getCoursesByOrgId
   */
  public getCoursesByOrgId(orgId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('orgId', orgId.toString());
    return this._http.get<[Course]>(environment.serverUrl + 'course/getByOrganization', {
      params: paramas,
    }).pipe(
      map(responseData => {
        this._courses = responseData;
        this.courses.next(responseData);
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * submitCourse
   */
  public submitCourse(orgId: string, course: Course, orgTypeId: number) {
    course.course = orgTypeId === 1;
    return this._http
      .post<Course>(
        environment.serverUrl + 'course/update',
        {
          'orgId': orgId,
          'course': course
        }
      ).pipe(
        map(responseData => {
          if (!course.id) {
            this._courses.push(responseData);
          } else {
            const index = this._courses.findIndex(oldCourse => oldCourse.id === course.id);
            this._courses[index] = responseData;
          }
          this.courses.next(this.getCourses());
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }


  /**
   * deleteScheduleById
   */
  public deleteCourseById(index: number) {
    let paramas = new HttpParams();
    // const scheduleId = this.schedules[index].id;
    const courseId = this._courses[index].id;
    paramas = paramas.append('id', courseId.toString());
    return this._http.delete<void>(environment.serverUrl + 'course', {
      params: paramas,
    }).pipe(
      map(() => {
        this._courses.splice(index, 1);
        this.courses.next(this._courses);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
